import { createFileRoute } from "@tanstack/react-router";
import { NuevaSolicitudPage, type TipoInicial } from "@/features/nueva-solicitud/components/NuevaSolicitudPage";
import { ErrorAlert } from "@/components/ui";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";

/** `?tipo=fb60|ca|oc` preselecciona el tipo (acciones rápidas del dashboard). */
interface NuevaSearch {
  tipo?: TipoInicial;
}

export const Route = createFileRoute("/_authed-tw/solicitudes/nueva")({
  validateSearch: (search: Record<string, unknown>): NuevaSearch => {
    const t = search.tipo;
    return t === "fb60" || t === "ca" || t === "oc" ? { tipo: t } : {};
  },
  component: RouteComponent,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});

function RouteComponent() {
  const { tipo } = Route.useSearch();
  return (
    <PermissionGate permisos={[PERMISOS.solicitudesGestionar]}>
      <NuevaSolicitudPage tipoInicial={tipo} />
    </PermissionGate>
  );
}
